"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import dynamic from "next/dynamic"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"

const DynamicSavedSearch = dynamic(() =>
  import("@/modules/jobAds/client/components/SavedSearch/SavedSearch").then(mod => mod.SavedSearch)
)

type InteractiveAsideProps = PropsWithChildren<{
  className?: string
  hasAside: boolean
}>

export const InteractiveAside: FunctionComponent<InteractiveAsideProps> = ({ children, className, hasAside }) => {
  useTranslation(["job_ads_fo", "shared_error", "shared_notification"], true)
  const { isUserLogged, savedSearch } = usePageContext()
  const hasAsideWithSavedSearch = hasAside || (isUserLogged && !!savedSearch)

  return (
    hasAsideWithSavedSearch && (
      <LayoutChild className={className} from={9} to={12}>
        {isUserLogged && <DynamicSavedSearch />}
        {children}
      </LayoutChild>
    )
  )
}
